import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSkuProjectProfileLookupComponent } from './default-sku-project-profile-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [DefaultSkuProjectProfileLookupComponent],
  exports: [DefaultSkuProjectProfileLookupComponent],
  providers: []
})
export class DefaultSKUProjectProfileLookupModule { }
